import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import {
  DxTextAreaModule,
  DxToolbarModule,
  DxButtonModule,
  DxValidationGroupModule,
  DxValidatorModule,
  DxScrollViewModule
} from 'devextreme-angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Notes, Note } from 'src/app/types/notes';

@Component({
  selector: 'card-notes',
  templateUrl: './card-notes.component.html',
  styleUrls: ['./card-notes.component.scss'],
  imports: [
    DxTextAreaModule,
    DxToolbarModule,
    DxButtonModule,
    DxValidationGroupModule,
    DxValidatorModule,
    DxScrollViewModule,
    CommonModule,
    TranslateModule,
  ]
})
export class CardNotesComponent {
  @Input() user: string;

  @Input() items: Notes;

  private t = inject(TranslateService);

  nodeText = '';

  /** Options del boton Add — DevExtreme no rebina pipes en options inline. */
  addButtonOptions = this.buildAddOptions();

  private buildAddOptions() {
    return {
      text: this.t.instant('crmContacts.cols.add'),
      stylingMode: 'contained' as const,
      type: 'default' as const,
      onClick: (e: any) => this.add(e),
    };
  }

  constructor() {
    this.t.onLangChange.subscribe(() => {
      this.addButtonOptions = this.buildAddOptions();
    });
  }

  add = (e) => {
    if (!e.validationGroup.validate().isValid) {
      return;
    }

    const newNote: Note = {
      manager: this.user,
      date: new Date(),
      text: this.nodeText,
    };

    this.items.push(newNote);

    e.validationGroup.reset();
  };
}
